import * as React from "react"
import { cn } from "../../lib/utils"

// Gabarit commun à toutes les pages : titre, contexte, actions — puis une
// barre d'outils. Une page qui l'utilise se lit comme les autres, sans avoir à
// réapprendre où sont la recherche et l'action principale.
interface PageHeaderProps {
  title: React.ReactNode
  /** Une ligne de contexte sous ou à côté du titre (« 48 inscrites · 6 sans heat »). */
  meta?: React.ReactNode
  /** Petite ligne au-dessus du titre (fil d'Ariane, statut). */
  eyebrow?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

function PageHeader({ title, meta, eyebrow, actions, className }: PageHeaderProps) {
  return (
    <div className={cn("flex flex-wrap items-end gap-x-4 gap-y-3", className)}>
      <div className="flex min-w-0 flex-col gap-1.5">
        {eyebrow && <div className="text-xs text-muted-foreground">{eyebrow}</div>}
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <h1 className="font-anton text-3xl uppercase leading-none tracking-[0.01em] text-foreground">{title}</h1>
          {meta && <span className="text-sm text-muted-foreground">{meta}</span>}
        </div>
      </div>
      {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}

function Toolbar({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex flex-wrap items-center gap-2", className)} {...props} />
}

export { PageHeader, Toolbar }
